export const CREATE_ACCOUNT = `
    mutation CreateAccount($name: String, $type: AccountEnum!, $image: String) {
        createAccount(name: $name, type: $type, image: $image) {
            name
            id
            type
            image
        }
    }
`;

export const UPDATE_ACCOUNT = `
    mutation UpdateAccount($id: Int! $name: String, $type_id: Int, $image: String, $remove_image: Boolean) {
        updateAccount(id: $id, name: $name, type_id: $type_id, image: $image, remove_image: $remove_image) {
            id
            name
            type
            image
        }
    }
`;

export const DELETE_ACCOUNT = `
    mutation DeleteAccount($id: In!) {
        deleteAccount(id: $id)
    }
`;

export const GRANT_USERS_INTO_ACCOUNT = `
    mutation GrantUsers($account_id: Int!, $users: [EmailRoleInput]) {
        grantUsers(account_id: $account_id, users: $users) {
            user_id
            email
            role
            invite_sent
            result
        }
    }
`;

export const GRANT_USER_ROLES_TO_ACCOUNT = `
    mutation GrantUserRole($account_id: Int!, $email: String!, $role: RoleEnum, $workspace_ids: [Int], $invite_to_team: Boolean) {
        grantUserRole(account_id: $account_id, email: $email, role: $role, workspace_ids: $workspace_ids, invite_to_team: $invite_to_team) {
            user_id
            email
            role
            invite_sent
            result
        }
    }
`;

export const UPDATE_USER_ROLE_IN_ACCOUNT = `
    mutation UpdateUserRole($account_id: Int!, $user_id: Int!, $role: RoleEnum) {
        updateUserRole(account_id: $account_id, user_id: $user_id, role: $role)
    }
`;

export const REVOKE_USER_ROLE_IN_ACCOUNT = `
    mutation RevokeUserRole($account_id: Int!, $user_id: Int!, $role_id: Int!) {
        RevokeUserRole(account_id: $account_id, user_id: $user_id, role_id: $role_id)
    }    
`;

export const REVOKE_ALL_USER_ROLES_IN_ACCOUNT = `
       mutation RevokeAllUserRoles($account_id: Int!, $user_id: Int! ) {
        revokeAllUserRoles(account_id: $account_id, user_id: $user_id)
    }
`;

export const ADD_FEATURE_ROLE_TO_ACCOUNT = `
    mutation AddFeatureRole($account_id: Int!, $user_id: Int!, $role: RoleEnum) {
        addFeatureRole(account_id: $account_id, user_id: $user_id, role: $role)
    }
`;

export const CREATE_ENTITY = `
    mutation CreateEntity($account_id: Int!, $project_id: Int!, $field_name: String!, $entity_name: EntityModelEnum, $field_type: EntityTypeEnum, $options: [String!]) {
        createEntity(account_id: $account_id, project_id: $project_id, field_name: $field_name, entity_name: $entity_name, field_type: $field_type, options: $options) {
            id
            field
            entity
            type
            options
            created_at
        }
    }
`;

export const UPDATE_ENTITY = `
    mutation UpdateEntity($account_id: Int!, $entity_mapping_id: Int!, $field_name: String, $entity_name: EntityModelEnum, $field_type: EntityTypeEnum, $options: [String]) {
        updateEntity(account_id: $account_id, entity_mapping_id: $entity_mapping_id, field_name: $field_name, entity_name: $entity_name, field_type: $field_type, options: $options) {
            id
            field
            entity
            type
            options
            created_at
        }
    }
`;
